import { useState } from 'react'

import * as stickyFeedbackMessage from 'scripts/utils/message'

import * as service from './services'
import { Form } from './components/Form'
import { Widget } from '../../components/Widget'

function LeadCapture () {
  const [isRequest, setIsRequest] = useState(false)

  const handleSubmit = data => {
    setIsRequest(true)
    service
      .signup(data)
      .then(() => {
        setIsRequest(false)
        stickyFeedbackMessage.success(
          'E-mail cadastrado com sucesso!',
          'Pronto!'
        )
      })
      .catch(() => {
        setIsRequest(false)
        stickyFeedbackMessage.error(
          'Ocorreu alguma instabilidade para cadastrar seu e-mail, tente novamente mais tarde!'
        )
      })
  }

  return (
    <Widget withBackground>
      <Form onSubmit={handleSubmit} isRequest={isRequest} />
    </Widget>
  )
}

export default LeadCapture
